import { createSlice } from "@reduxjs/toolkit";
import { saveShipping, fetchShippingList } from "./shippingThunk";

const initialState = {
    shipping_type: "sales",
    sscc_code: "",
    sender_gln: "",
    receiver_gln: "",
    sender_gcp_length: 10,
    receiver_gcp_length: 10,
    saving: false,
    list: [],
    listLoading: false,
};

const shippingSlice = createSlice({
    name: "tatmeenShipping",
    initialState,
    reducers: {
        setFormField(state, action) {
            const { field, value } = action.payload;
            state[field] = value;
        },
        resetShippingForm(state) {
            state.shipping_type = "sales";
            state.sscc_code = "";
            state.sender_gln = "";
            state.receiver_gln = "";
            state.sender_gcp_length = 10;
            state.receiver_gcp_length = 10;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(saveShipping.pending, (state) => {
                state.saving = true;
            })
            .addCase(saveShipping.fulfilled, (state) => {
                state.saving = false;
            })
            .addCase(saveShipping.rejected, (state) => {
                state.saving = false;
            })
            .addCase(fetchShippingList.pending, (state) => {
                state.listLoading = true;
            })
            .addCase(fetchShippingList.fulfilled, (state, action) => {
                state.listLoading = false;
                state.list = action.payload;
            })
            .addCase(fetchShippingList.rejected, (state) => {
                state.listLoading = false;
            });
    },
});

export const { setFormField, resetShippingForm } = shippingSlice.actions;

export default shippingSlice.reducer;
